import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes, multiLangType} from "../common/enums/ExcelEnum";
import {LangType, TranslationLangType} from "../common/enums/ContentEnum";

const logPrefix  = "[EvenStepSevenStore]"
export default class EvenStepSevenStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentTapIndex = 0;
        this.contentList = [];
        this.selectedContent = [];
        this.translationContents = {};
        this.requestTranslations = [];

        this.readyToSaveStep = false;
        this.stepValue = 0;
        this.dayValue = 0;

        makeAutoObservable(this);
    }

    initEvenStepSevenContent = () => {
        this.contentList = [];
        this.selectedContent = [];
        this.contentTapIndex = 0;
        this.translationContents = {};
        this.requestTranslations = [];
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }


    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode());
    }

    setTranslationContents = (translations) => {
        translations.sort((a, b) => multiLangType.indexOf(a.languageCode) - multiLangType.indexOf(b.languageCode)).forEach(content => {
            if (!this.translationContents[content.languageCode]) {
                this.translationContents[content.languageCode] = [];
            }
            this.translationContents[content.languageCode].push(content);
        });
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setTranslateText = (text, index, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent[index].text = text;
        this.setTranslate(lang, index);
    }

    setTranslateDisplay = (isEnable, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent.forEach((c, index) => {
            c.enable = isEnable;
            this.setTranslate(lang, index);
        });
    }

    getAiTranslate = (lang) => {
        this.getSelectedContent(LangType.EN).forEach((c, i) => {
            this.contentStore.getGeneratedTranslate(lang, c.text, (translatedText) => this.setTranslateText(translatedText, i, lang));
        });
    }

    setTranslate = (lang, index) => {
        let translationContent = this.translationContents[lang].slice();
        const targetContent = translationContent[index];
        this.translationContents = {
            ...this.translationContents,
            [lang]: translationContent,
        };

        const contentIdx = this.requestTranslations.findIndex(r => r.id === targetContent.id);
        if (contentIdx === -1) {
            this.requestTranslations.push(targetContent);
        } else {
            this.requestTranslations[contentIdx] = targetContent;
        }
        this.contentStore.setReadyToSaveStep(this.isEvenStepSevenCompleted() && !!this.requestTranslations.length);
        this.readyToSaveStep = this.isEvenStepSevenCompleted() && !!this.requestTranslations.length;
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    isEvenStepSevenCompleted = () => {
        let hasEmptyValues = false;

        for (const lang of Object.keys(TranslationLangType)) {
            if (this.translationContents[lang].some(content => content.text === '')) {
                hasEmptyValues = true;
                break;
            }
        }

        return !hasEmptyValues;
    }

    * getEvenStepSevenContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepSevenContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/7`;
            const response = yield this.contentRepository.getContent(url);

            if (response.data !== null) {
                const { contents, translations } = response.data;
                this.contentList = contents;
                this.setTranslationContents(translations);
            }

            this.contentStore.setReadyToMoveExit(this.isEvenStepSevenCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            this.setSelectedContent();
            console.log(logPrefix, 'Finished getEvenStepSevenContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepSevenContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepSevenContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepSevenContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/7`;
            console.log(logPrefix, 'modifyEvenStepSevenContent requestContents :', this.requestTranslations);
            yield this.contentRepository.putContent(url, this.requestTranslations);
            console.log(logPrefix, 'Finished modifyEvenStepSevenContent.');
            this.requestTranslations = [];
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            // this.openErrorDialog({
            //     titleText: '저장 성공',
            //     text: displayErrorDialogPrompt('',  '컨텐츠를 정상적으로 저장하였습니다.')
            // });
        } catch (e) {
            console.log(logPrefix, 'Failed modifyEvenStepSevenContent.');
            this.openErrorDialog({
                titleText: '대화문 번역 수정 오류',
                text: displayErrorDialogPrompt(e, '대화문 번역 수정 작업중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

}

